<template>
  <div class="key-dates">
    <div class="key-dates__header">Key upcoming dates</div>
    <div class="key-dates__info">
      27 September 2018
      <span>Ex dividend date</span>
    </div>
    <div class="key-dates__info">
      28 September 2018
      <span>Interim dividend record date</span>
    </div>
    <div class="key-dates__info">
      05 November 2018
      <span>Interim dividend payment date</span>
    </div>
    <div class="key-dates__link">
      <BaseButton class="investor-banner__button" variant="white" width="full">
        See financial calendar
        <BaseIcon name="arrow_forward" size="18"></BaseIcon>
      </BaseButton>
    </div>
  </div>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
export default {
  name: 'KeyUpcomingDates',
  components: { BaseButton, BaseIcon }
}
</script>


<style lang="postcss">
.key-dates::before,
.key-dates::after {
  @apply absolute block bg-white shadow-md top-0 -mt-4;
  content: '';
  width: 11px;
  height: 32px;
  border-radius: 16px;
}
.key-dates::before {
  @apply ml-12;
}
.key-dates::after {
  @apply mr-12 right-0;
}
.key-dates {
  @apply rounded-lg shadow-md w-full relative mb-16;
}
.key-dates__header {
  @apply bg-primary px-6 pt-6 pb-4 text-xl text-white rounded-lg rounded-b-none;
}
.key-dates__info {
  @apply text-lg font-semibold border border-t-0 border-l-0 border-r-0 border-body-lighter px-6 py-4;
}
.key-dates__info span {
  @apply block font-normal text-body;
}
.key-dates__link {
  @apply relative text-secondary px-6;
}
.key-dates__icon {
  @apply block fill-current absolute right-0 mr-6 top-0 mt-4 z-0;
}
</style>
